// src/plugins/axios.js
import axios from "axios";
import store from "../store";
import router from "../router";

const apiClient = axios.create({
  baseURL: "/api",
  headers: {
    "Content-Type": "application/json",
  },
});

apiClient.interceptors.request.use(
  (config) => {
    const token = store.state.loginAndOut.token;
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Set up response interceptor
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (
      error.response &&
      (error.response.status === 401 || error.response.status === 403)
    ) {
      store.dispatch("loginAndOut/logout"); // Clear loginAndOut state
      router.push("/login"); // Redirect to login page
    }
    return Promise.reject(error);
  }
);

export default apiClient;
